import { GridColumn } from '@progress/kendo-react-grid'
import { useSetAtom } from 'jotai'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { createBreadcrumbWithI18n } from '~/apps/applicationAdmin/routes/paths'
import {
  PageContainer,
  type PageContainerProps,
} from '~/components/elements/PageContainer'
import {
  StyledButton,
  type StyledButtonProps,
} from '~/components/elements/StyledButton'
import { StyledGrid } from '~/components/elements/StyledGrid'
import { VStack } from '~/components/elements/VStack'

import { dialogInfoAtom } from '../atoms'
import { useMainQueryBrandAccounts } from '../hooks/useMainQuery'
import { pathKey } from '../utils'

import { CommandsCell } from './CommandsCell'
import { Dialogs } from './Dialogs'
import { IdCell } from './IdCell'
import { NameCell } from './NameCell'
import { PartnerCell } from './PartnerCell'
import { UserCell } from './UserCell'

export const BrandAccountsList = () => {
  const { t } = useTranslation()
  const brandAccounts = useMainQueryBrandAccounts()

  const createBreadcrumb = React.useMemo(() => createBreadcrumbWithI18n(t), [t])

  const breadcrumbs: PageContainerProps['breadcrumbs'] = React.useMemo(
    () => [createBreadcrumb('top', {}), createBreadcrumb(pathKey, {})],
    [createBreadcrumb],
  )

  const setDialogInfo = useSetAtom(dialogInfoAtom)
  const handleAddButtonClick = React.useCallback<
    EH<StyledButtonProps, 'onClick'>
  >(() => {
    setDialogInfo({ dialogType: 'create' })
  }, [setDialogInfo])

  return (
    <PageContainer breadcrumbs={breadcrumbs}>
      <VStack align="end" spacing={2} verticalAppearance="stretch">
        <StyledButton
          buttonStyle="success"
          fillMode="outline"
          icon="add"
          onClick={handleAddButtonClick}
        >
          {t('add')}
        </StyledButton>

        <StyledGrid data={brandAccounts} editField="inEdit">
          <GridColumn cell={IdCell} title="ID" />

          <GridColumn cell={NameCell} title={t('name')} />

          <GridColumn
            cell={PartnerCell}
            title={t('partner_seats')}
            width={130}
          />

          <GridColumn cell={UserCell} title={t('user_seats')} width={130} />

          <GridColumn cell={CommandsCell} width={30 * 2 + 25} />
        </StyledGrid>

        <Dialogs />
      </VStack>
    </PageContainer>
  )
}
